import store from '../store/index'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import(/* webpackChunkName: "Home" */ "../views/home.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/produtos/:category/:id',
        name: 'products',
        component: () => import(/* webpackChunkName: "Products" */ "../views/products/products.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/produtos/buscar/:searchTerm',
        name: 'search',
        component: () => import(/* webpackChunkName: "Search" */ "../views/products/products.vue"),
        meta: { requiresAuth: true },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "Login" */ "../views/login.vue"),
    },
    {
        path: '/pre-cadastro/:token',
        name: 'Pré Cadastro',
        component: () => import(/* webpackChunkName: "Pré Cadastro" */ "../views/preCadastro.vue"),
    },
    {
        path: '/logout',
        name: 'logout',
        component: () =>
            import(/* webpackChunkName: "Logout" */ "../views/login.vue"),
        meta: { requiresAuth: true }
    },
    {
        path: '/evento/:url',
        name: 'Formulário de Evento',
        component: () => import(/* webpackChunkName: "FormView" */ "../views/events/form.vue"),
    },

    //Menus
    {
        path: '/configuracoes',
        name: 'settings',
        component: () =>
            import(/* webpackChunkName: "Settings" */ "../views/config/config.vue"),
        meta: { requiresAuth: true },
        menu: {
            icon: 'mdi-cog',
            title: 'Configurações',
            order: 1,
            levelId: 2
        }
    },
    {
        path: '/categories',
        name: 'categories',
        component: () => import(/* webpackChunkName: "Categories" */ "../views/categories/categoriesHome.vue"),
        meta: { requiresAuth: true },
        menu: {
            icon: 'mdi-animation',
            title: 'Categorias',
            order: 2,
            levelId: 2
        }
    },
    {
        path: '/productsAdmin',
        name: 'productsAdmin',
        component: () => import(/* webpackChunkName: "ProductsAdmin" */ "../views/productsAdmin/productsAdmin.vue"),
        meta: { requiresAuth: true },
        menu: {
            icon: 'mdi-palette-swatch',
            title: 'Produtos',
            order: 3,
            levelId: 2
        }
    },
    {
        path: '/orders',
        name: 'orders',
        component: () => import(/* webpackChunkName: "Orders" */ "../views/ordersAdmin/ordersView.vue"),
        meta: { requiresAuth: true },
        menu: {
            icon: 'mdi-shopping',
            title: 'Pedidos',
            order: 4,
            levelId: 2
        }
    },
    {
        path: '/events',
        name: 'Eventos',
        component: () => import(/* webpackChunkName: "EventsView" */ "../views/events/events.vue"),
        meta: { requiresAuth: true },
        menu: {
            icon: 'mdi-calendar-star',
            title: 'Eventos',
            order: 5,
            levelId: 2
        }
    },
    {
        path: '/form-rules',
        name: 'Regras de Formulários',
        component: () => import(/* webpackChunkName: "LeadFormRulesView" */ "../views/leadFormRules/leadFormRulesView.vue"),
        meta: { requiresAuth: true },
        menu: {
            icon: 'mdi-lead-pencil',
            title: 'Regras de Formulários',
            order: 6,
            levelId: 2
        }
    },
    {
        path: '/lead-submissions',
        name: 'Relatório de Leads de Formulários',
        component: () => import(/* webpackChunkName: "LeadSubmissions" */ "../views/leadSubmissions/leadSubmissionsView.vue"),
        meta: { requiresAuth: true },
        menu: {
            icon: 'mdi-account-box-multiple',
            title: 'Relatório de Leads de Formulários',
            order: 7,
            levelId: 2
        }
    },
    {
        path: '/admin',
        name: 'superAdmin',
        component: () => import(/* webpackChunkName: "Administration" */ "../views/admin/admin.vue"),
        meta: { requiresAuth: true },
        menu: {
            icon: 'mdi-crown',
            title: 'Super Admin',
            order: 10,
            levelId: 1
        }
    },
    
    // Not Found
    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: () =>
            import(/* webpackChunkName: "NotFound" */ "../views/notFound.vue"),
        meta: { requiresAuth: true }
    },
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    const logged = store.getters.getLogged;
    document.title = `${process.env.VUE_APP_TITLE} - ${to.name}`.toUpperCase();

    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
    if (!requiresAuth) {
        return next();
    }

    if (!logged) {
        return next({ path: '/login' });
    }

    // A partir daqui, o usuário ESTÁ LOGADO e em uma ROTA PROTEGIDA.

    const routeWithPermission = routes.find(record => record.menu && record.menu.levelId !== undefined && record.name === to.name);
    if (!routeWithPermission) {
        return next();
    }

    const userLevel = store.state.user.level;
    const requiredLevel = routeWithPermission.menu.levelId;

    if (userLevel <= requiredLevel) {
        return next();
    } else {
        console.warn(`ACESSO NEGADO para '${to.name}'.`);
        return next({ name: 'home' });
    }
});
export default router